const formatTimeframe = timeframe => {
  if (timeframe === null) {
    return;
  }
  return timeframe
    .replace('Less Than', '<')
    .replace(/(\d) (Years|Months) And Beyond/, '$1+ $2')
    .replace(/(\d) Months To (\d) (Years?)/, '$1 Mo - $2 Yr')
    .replace(/\s(Years?|Months?) To /g, '-');
};

export default formatTimeframe;
